import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Crown, Loader2 } from 'lucide-react';
import api from '@/utils/api';

export const BetaModal = ({ open, onOpenChange, onSuccess }) => {
  const [codeOrEmail, setCodeOrEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleActivate = async () => {
    if (!codeOrEmail.trim()) return;

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/beta/activate', null, {
        params: { code_or_email: codeOrEmail.trim() }
      });

      if (onSuccess) {
        onSuccess(response.data.message);
      }
      setCodeOrEmail('');
      onOpenChange(false);
    } catch (err) {
      setError(err.response?.data?.detail || 'Código o email inválido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Crown className="w-5 h-5 text-yellow-500" />
            Acceso Beta Tester
          </DialogTitle>
          <DialogDescription>
            Introduce tu código de beta tester o email autorizado para acceder a todas las funciones gratis.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Input
              placeholder="Código o email"
              value={codeOrEmail}
              onChange={(e) => {
                setCodeOrEmail(e.target.value);
                setError('');
              }}
              onKeyPress={(e) => e.key === 'Enter' && handleActivate()}
            />
            {error && (
              <p className="text-sm text-red-500 mt-2">{error}</p>
            )}
          </div>

          <Button 
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white" 
            onClick={handleActivate}
            disabled={loading || !codeOrEmail.trim()}
          >
            {loading ? (
              <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Verificando...</>
            ) : (
              <>Activar Acceso Beta</>
            )}
          </Button>

          <p className="text-xs text-center text-gray-500">
            ¿No tienes código? Contacta con el desarrollador para solicitar acceso beta.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};